import React from "react";
import { useTranslation } from "react-i18next";

export default function StocksTransactionTable(props) {
  const { t } = useTranslation();
  console.log(props);
  return (
    <div className="table-wrapper px-3 pt-3">
      <div className="table-wrapper-scrol-y table-scrollbar">
        <div className="table-own table-responsive">
          <table className="table table-admin">
            <thead className="table-head">
              <tr>
                <th>
                  <span>{t("common.slNo")}</span>
                </th>
                <th>
                  <span>{t("common.quantity")}</span>
                </th>
                <th>
                  <span>{t("admin.stockTransactions.productName")}</span>
                </th>
                <th>
                  <span>{t("common.date")}</span>
                </th>
                <th>
                  <span>{t("common.time")}</span>
                </th>
                <th>
                  <span>{t("common.notes")}</span>
                </th>
                <th>
                  <span>{t("admin.stockTransactions.user")}</span>
                </th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props?.dataList?.map((data, i) => {
                let dateNow = "",
                  timeNow = "";
                if (data?.timestamp) {
                  const { timestamp } = data;
                  const dateObj = new Date(timestamp);
                  dateNow = dateObj.toLocaleDateString("en-UK", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  });
                  timeNow = dateObj.toLocaleTimeString("en-UK", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  });
                }

                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{data?.stockQuantity}</td>
                    <td>{data?.orgProduct?.name}</td>
                    <td>{dateNow}</td>
                    <td>{timeNow}</td>
                    <td>{data?.notes || "-"}</td>
                    <td>{data?.adminUser?.email}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
